export enum AssignPickupType {
    SystemAssign = 0,
    EmployeeAssign = 1
}
